var _defs, _g, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "border",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.08 259.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#f8f7f7;stroke-linecap:round;stroke-width:2.2px;stroke-dasharray:7.07 7.07;}.cls-2{stroke:#f9f8f7;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "animate-paths-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "border-2",
    "data-name": "border"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.65,
    cy: 118.16,
    r: 103.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-ar",
    stroke: "#f8f7f7",
    strokeWidth: "2px",
    "data-name": "right-ar",
    className: "cls-2 hide-me",
    d: "M153,280.07c2-32.95,4.13-92-7.31-122.93-6.19-16.77-17.36-33-34.2-39S72.24,121,69,138.52c-2.88,15.49,9.34,30,22.94,37.89,26.83,15.67,63,14.82,87.92-3.73s36-54.41,24.14-83.12c-5.6-13.52-18.66-26.16-33-23.45-10.48,2-17.92,11.46-22.21,21.22-10.19,23.22-7.67,50.52,1.79,74,5.07,12.61,12.27,24.71,22.88,33.19,19.18,15.32,47.62,16.18,69.5,5.05s37.32-32.71,44.53-56.17",
    transform: "translate(-9.77 -20.78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "middle-ar",
    stroke: "#f8f7f7",
    strokeWidth: "2px",
    "data-name": "middle-ar",
    className: "cls-2 hide-me",
    d: "M151,20.87c4.1,65.41,2.12,193.66,2,259.2",
    transform: "translate(-9.77 -20.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "left-ar",
    stroke: "#f8f7f7",
    strokeWidth: "2px",
    "data-name": "left-ar",
    className: "cls-2 hide-me",
    d: "M11.17,145.52c7.06,18.4,22.61,41.86,39.75,51.58s39.71,10.95,56.22.18c9.68-6.31,16.62-16.08,22-26.32C147.16,136.38,152.43,54.43,151,20.87",
    transform: "translate(-9.77 -20.78)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.34d1b91e.svg";
export { ForwardRef as ReactComponent };